// CountCert.jsx - Enhanced certifications counter
import React, { useEffect } from 'react';
import { Card, Statistic, Space, Tag, Progress, Tooltip, Typography } from 'antd';
import { SafetyCertificateOutlined, CheckCircleOutlined, ClockCircleOutlined } from '@ant-design/icons';
import { getCerts } from '../../features/certs/certSlice';
import { useDispatch, useSelector } from 'react-redux';

const { Text } = Typography;

const CountCert = () => {
  const { certs, loading } = useSelector((state) => state.certs);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getCerts());
  }, [dispatch]);

  // Calculate stats
  const activeCerts = certs?.filter(cert => cert.status === 'active')?.length || 0;
  const expiredCerts = certs?.filter(cert => cert.status === 'expired')?.length || 0;
  const totalCerts = certs?.length || 0;
  const activeRate = totalCerts > 0 ? Math.round((activeCerts / totalCerts) * 100) : 0;

  return (
    <Card 
      className="shadow-medium border border-border-light rounded-xl bg-white hover:shadow-hard transition-all duration-300 h-full"
      bodyStyle={{ padding: '24px' }}
      loading={loading}
    >
      <div className="text-center">
        <div className="flex justify-center mb-4">
          <div className="w-16 h-16 bg-gradient-to-br from-accent-green to-green-600 rounded-full flex items-center justify-center">
            <SafetyCertificateOutlined className="text-2xl text-white" />
          </div>
        </div>
        
        <Statistic
          title={
            <span className="text-text-secondary font-medium text-sm uppercase tracking-wide">
              Certifications
            </span>
          }
          value={totalCerts}
          valueStyle={{
            color: '#10b981',
            fontSize: '3rem',
            fontWeight: 'bold',
            fontFamily: 'Montserrat'
          }}
        />

        <Space direction="vertical" size="small" className="w-full mt-4">
          <div className="flex justify-between items-center">
            <Text className="text-text-secondary text-sm">Active Rate</Text>
            <Text className="text-accent-green font-semibold">{activeRate}%</Text>
          </div>
          <Progress 
            percent={activeRate} 
            strokeColor="#10b981"
            trailColor="#f1f5f9"
            strokeWidth={8}
            showInfo={false}
          />
          
          <div className="flex justify-between mt-3">
            <Tooltip title="Active Certifications">
              <Tag color="green" className="flex items-center space-x-1">
                <CheckCircleOutlined />
                <span>{activeCerts}</span>
              </Tag>
            </Tooltip>
            <Tooltip title="Expired/Expiring">
              <Tag color="red" className="flex items-center space-x-1">
                <ClockCircleOutlined />
                <span>{expiredCerts}</span>
              </Tag>
            </Tooltip>
          </div>
        </Space>
      </div>
    </Card>
  );
};

export default CountCert;